import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/stores/authContext';
import { useIsCarrier } from '@/hooks/useRoles';
import { ROUTES } from '@/routes/paths';

// Ограничение доступа к разделу: он доступен только роли CARRIER. Стоит ВНУТРИ RequireAuth, поэтому
// аутентификация уже гарантирована — проверяем лишь роль. Не-перевозчика уводим на «Главное» (а не 404 —
// раздел реален, просто не его). Бэкенд дублирует запрет (403), это страховка от прямого захода по URL.
export default function RequireCarrier() {
  const { isInitializing } = useAuth();
  const isCarrier = useIsCarrier();

  if (isInitializing) {
    return (
      <Center h="50vh">
        <Loader />
      </Center>
    );
  }
  return isCarrier ? <Outlet /> : <Navigate to={ROUTES.APP} replace />;
}
